/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main[_ngcontent-%COMP%]{min-height:400px;min-height:calc(100vh - 288px);padding:16px}.sidenav[_ngcontent-%COMP%]{width:250px;padding:8px 16px;position:fixed}.sidenav[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{margin-left:178px}.sidenav[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]{margin:8px 0}.cart-items-count[_ngcontent-%COMP%]{position:absolute;top:-3px;left:26px;background:#f44336;height:18px;width:18px;line-height:18px;border-radius:50%;font-size:11px}"];
export { styles as styles };
